import { InfoCardProps } from "./types";

import "./styles.css";

const DEFAULT_ICON_BACKGROUND_COLOR = "var(--primary-1000)";
const DEFAULT_ICON_COLOR = "var(--base-white)";

const InfoCard = ({
  icon,
  title,
  description,
  iconBackgroundColor = DEFAULT_ICON_BACKGROUND_COLOR,
  iconColor = DEFAULT_ICON_COLOR,
}: InfoCardProps) => {
  return (
    <div className={`info-card flex flex-col gap-300 full-width`}>
      <div
        className="info-card-icon flex justify-center items-center"
        style={{
          backgroundColor: iconBackgroundColor,
          color: iconColor,
        }}
      >
        {icon}
      </div>

      <h3 className="info-card-title body-m-medium">{title}</h3>

      {description != null && description !== "" && (
        <p className="info-card-description body-m-regular">{description}</p>
      )}
    </div>
  );
};

export default InfoCard;
